// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"0f4353f5","2902":"1498db80","2972":"0f4353f5","5100":"0f4353f5","6817":"bf72e7f5"}[chunkId] + ".chunk.css";
};